import ModalDocumentUpload from '../documents/ModalDocumentUpload';
import OmButton from '../ui/OmButton';

const DocumentUploadModal = ({ show, onClose, claim, onUploadSuccess }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-carbon-black bg-opacity-60 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-0 border border-steel/20 w-11/12 max-w-4xl shadow-depth bg-crystal-white">
        <div className="card-header flex items-center justify-between">
          <h3 className="text-lg font-display font-semibold text-crystal-white">
            Upload Documents for Claim #{claim.id}
          </h3>
          <OmButton
            onClick={onClose}
            buttonType="ghost-button"
            buttonSize="small"
            trailingIcon="close"
            className="text-crystal-white hover:text-crystal-white/80 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-crystal-white/20"
          >
          </OmButton>
        </div>
        
        <div className="card-body">
          <div className="bg-silver-mist border-l-4 border-info p-4 mb-6">
            <p className="text-sm text-graphite leading-relaxed">
              Upload supporting documents for this claim. Files should be less than 10MB in size.
              Accepted formats include PDF, JPG, PNG, and Office documents.
            </p>
          </div>
          
          <ModalDocumentUpload
            formData={claim || {}}
            uploadedFiles={claim?.documents || []}
            onFileUpload={() => {}}
            onFileRemove={() => {}}
            isLoading={false}
            errors={{}}
            validationErrors={{}}
            schema={{}}
            showError={() => {}}
            onUploadSuccess={onUploadSuccess}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentUploadModal;
